import React from 'react';
import ReactApexChart from 'react-apexcharts';

const calculateMaxValue = (type, chartSeries) => {
  const series = chartSeries.filter((s) => s.type === type);
  const maxValue = Math.max(...series.map((s) => Math.max(...s.data)));

  const digits = String(maxValue).length; // 자리수 계산
  const roundDigit = digits - 1; // 반올림하고자 하는 자리수 계산
  const roundBase = Math.pow(10, roundDigit); // 반올림 기준값 계산
  const rounded = Math.ceil(maxValue / roundBase) * roundBase; // 무조건 올림

  return Math.max(rounded);
};

const calculateSeriesMaxValue = (yaxis, chartSeries) => {
  const series = chartSeries.filter((s) => s.yaxis === yaxis);
  const maxValue = Math.max(...series.map((s) => Math.max(...s.data)));

  const integerPart = Math.floor(maxValue); // 소수점 이하는 버리고 정수 부분만 사용
  const digits = String(integerPart).length; // 자리수 계산
  const roundDigit = digits - 1; // 반올림하고자 하는 자리수 계산
  const roundBase = Math.pow(10, roundDigit); // 반올림 기준값 계산
  const rounded = Math.ceil(maxValue / roundBase) * roundBase; // 무조건 올림

  console.log('🔥csl🔥CombinePairsChart/calculateSeriesMaxValue :25 - maxValue = ', maxValue);
  console.log('🔥csl🔥CombinePairsChart/calculateSeriesMaxValue :25 - digits = ', digits);
  console.log('🔥csl🔥CombinePairsChart/calculateSeriesMaxValue :25 - roundDigit = ', roundDigit);
  console.log('🔥csl🔥CombinePairsChart/calculateSeriesMaxValue :25 - roundBase = ', roundBase);
  console.log('🔥csl🔥CombinePairsChart/calculateSeriesMaxValue :26 - rounded = ', rounded);
  return rounded == maxValue ? rounded * 1.3 : rounded;
};

export default function GroupChart(props) {
  const { categories, series, yaxis, tooltip, title } = props;

  const columnMax = calculateMaxValue('column', series);
  const lineMax = calculateMaxValue('line', series);

  const newYaxis = yaxis.map((axis, index) => {
    if (series) {
      const yaxis = series[index].yaxis;
      return {
        ...axis,
        max: calculateSeriesMaxValue(yaxis, series)
      };
    } else {
      return axis;
    }
  });

  const chartOptions = {
    title: {
      text: title,
      align: 'center'
    },
    chart: {
      id: 'combo-chart',
      width: '100%',
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      },
      stacked: false,
      events: {
        // legendClick: function (chartContext, seriesIndex, config) {
        //   console.log('Legend clicked for series: ' + seriesIndex);
        //   // Implement your custom behavior here.
        // }
      }
    },
    legend: {
      position: 'right'
    },
    colors: ['#FEB019', '#FF4560', '#008FFB', '#00E396'],
    stroke: {
      width: [3, 3, 3, 3]
    },
    plotOptions: {
      bar: {
        columnWidth: '50%'
      }
    },
    markers: {
      size: 5,
      hover: {
        size: 6
      }
    },
    dataLabels: {
      enabled: false
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'],
        opacity: 0.5
      }
    },
    xaxis: {
      categories: categories || ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      tickPlacement: 'between'
    },
    yaxis: newYaxis || exampleYaxis,
    tooltip: tooltip || exampleTooltip
  };

  const chartSeries = series || exampleSeries;

  return (
    <div className="chart-container">
      <ReactApexChart options={chartOptions} series={chartSeries} type="line" height={300} />
    </div>
  );
}

const exampleYaxis = [
  {
    showAlways: true,
    title: {
      text: 'Product A'
    }
  },
  {
    show: false,
    title: {
      text: 'Product B'
    }
  },
  {
    showAlways: true,
    opposite: true,
    title: {
      text: 'Growth A'
    }
  },
  {
    show: false,
    opposite: true,
    title: {
      text: 'Growth B'
    }
  }
];

const exampleSeries = [
  {
    name: 'Product A',
    type: 'column',
    data: [30, 40, 35, 50, 49, 3000, 60, 91, 125, 150, 8000, 230],
    yaxis: 0
  },
  {
    name: 'Product B',
    type: 'column',
    data: [30, 50, 50, 50, 49, 60, 6000, 91, 125, 150, 200, 3000],
    yaxis: 1
  },
  {
    name: 'Growth A',
    type: 'line',
    data: [44, 55, 41, 67, 22, 43, 21, 49, 30, 25, 44, 12],
    yaxis: 2
  },
  {
    name: 'Growth B',
    type: 'line',
    data: [13, 23, 20, 8, 13, 27, 22, 17, 15, 29, 18, 13],
    yaxis: 3
  }
];

const exampleTooltip = {
  y: [
    {
      title: {
        formatter: function (val) {
          return val + ' (건)';
        }
      },
      formatter: function (val) {
        return val + ' (건)';
      }
    },
    {
      title: {
        formatter: function (val) {
          return val + ' (개)';
        }
      }
    },
    {
      formatter: function (val) {
        return val + ' (원)';
      }
    },
    {
      formatter: function (val) {
        return val + ' (원)';
      }
    }
  ]
};
